import { getErrorMessage } from '@/utils/errorUtils';

import { supabase } from '../client';

/**
 * Delete a score record
 */
export const deleteScore = async (scoreId: string) => {
  try {
    // Due to ON DELETE CASCADE, deleting the score will automatically delete
    // related records in score_games and score_presence
    const { error } = await supabase
      .from('scores')
      .delete()
      .eq('id', scoreId);
    
    if (error) {
      console.error('Error deleting score:', error);
      return { error: error.message };
    }
    
    return { success: true };
  } catch (error) {
    console.error('Unexpected error in deleteScore:', error);
    return { error: getErrorMessage(error) };
  }
};
